import type { DocStatus } from "../../../shared/types";
export type { DocStatus };

interface StatusBadgeProps {
  status: DocStatus;
}

const STATUS_STYLES: Record<DocStatus, React.CSSProperties> = {
  draft: { color: "var(--fg-3)" },
  review: { color: "var(--fg-3)" },
  published: { color: "var(--fg-3)" },
  superseded: { color: "var(--fg-3)" },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span style={{ ...styles.badge, ...STATUS_STYLES[status] }}>{status}</span>
  );
}

const styles: Record<string, React.CSSProperties> = {
  badge: {
    display: "inline-block",
    fontFamily: "var(--font-mono)",
    fontSize: 11,
    fontWeight: 400,
    letterSpacing: 0,
  },
};
